/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ state: NonNullable<unknown> }} Explorer_Info_State_Updated_ToastInputs */

const en_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`State updated to "${i?.state}"`)
};

const fr_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etat mis a jour vers "${i?.state}"`)
};

const de_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status aktualisiert auf "${i?.state}"`)
};

const it_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stato aggiornato a "${i?.state}"`)
};

const ru_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Состояние обновлено до "${i?.state}"`)
};

const es_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estado actualizado a "${i?.state}"`)
};

const zh_cn2_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`状态已更新为“${i?.state}”`)
};

const ja_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`状態が「${i?.state}」に更新されました`)
};

const hi_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`राज्य को "${i?.state}" में अपडेट किया गया`)
};

const pt_pt2_explorer_info_state_updated_toast = /** @type {(inputs: Explorer_Info_State_Updated_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estado atualizado para "${i?.state}"`)
};

/**
* | output |
* | --- |
* | "State updated to \"{state}\"" |
*
* @param {Explorer_Info_State_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_state_updated_toast = /** @type {((inputs: Explorer_Info_State_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_State_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_state_updated_toast(inputs)
	if (locale === "de") return de_explorer_info_state_updated_toast(inputs)
	if (locale === "it") return it_explorer_info_state_updated_toast(inputs)
	if (locale === "ru") return ru_explorer_info_state_updated_toast(inputs)
	if (locale === "es") return es_explorer_info_state_updated_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_state_updated_toast(inputs)
	if (locale === "ja") return ja_explorer_info_state_updated_toast(inputs)
	if (locale === "hi") return hi_explorer_info_state_updated_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_state_updated_toast(inputs)
	return en_explorer_info_state_updated_toast(inputs)
});